import React, { useState } from 'react';
import NavigateButton from '../buttons/NavigateButton';
import LearnerBadge from '../LearnerBadge';
import GuestConfirmDialog from '../GuestConfirmDialog';
import { getCurrentUserId, isGuestAllowed } from '../../utils/session';
import { isAdmin } from '../../config/learners';

// Home は「学習者がログインした直後の最初の画面」という位置づけ。
// ログイン（番号選択）は /login で行い、ここでは右上に自分の番号を出して
// 取り違えにその場で気づけるようにする（LearnerBadge から選び直せる）。
// Home 自体はログイン必須にしない（デモが開けるように）。
// 管理者セクションとシステムデモは管理者番号（999）でログインしたときだけ出す（学習者には見せない。
// デモは「押さないでください」と書いて見せるより、出さないほうが迷わないため。2026-10-15）。
// Home は route state を受け取らない（遷移元から何も渡さない）。
// 演習ボタン（confirmGuest）は、番号を選んでいないと確認モーダルを先に出し、
// 「そのまま進める」なら番号なしで演習へ進める（GuestConfirmDialog）。
const SECTIONS = [
  {
    title: '演習',
    note: '実験ではこの2つの演習に取り組みます。\n指示に従ってボタンを押して演習に進んでください。',
    buttons: [
      { to: '/ex1-2026-shape', buttonText: '形状変更演習', confirmGuest: true },
      { to: '/ex1-2026-gaze', buttonText: '視点変更演習', confirmGuest: true },
    ],
  },
  {
    title: 'システムデモ',
    note: '研究発表用のデモ（管理者番号でログインしたときだけ表示されます）',
    adminOnly: true,
    buttons: [
      { to: '/suggest2', buttonText: '形状変更ガイドデモ', className: 'btn--secondary' },
      { to: '/demo3', buttonText: '視点変更ガイドデモ', className: 'btn--secondary' },
    ],
  },
  {
    title: '管理者',
    note: '管理者番号でログインしたときだけ表示されます',
    adminOnly: true,
    buttons: [
      { to: '/teacher', buttonText: '管理者画面', className: 'btn--gray w-full' },
    ],
  },
];

function Home() {
  const userId = getCurrentUserId();
  const admin = isAdmin(userId);
  const sections = SECTIONS.filter((section) => !section.adminOnly || admin);
  // 確認モーダルを出している演習の遷移先（null なら出していない）
  const [guestTarget, setGuestTarget] = useState(null);
  const needsConfirm = userId == null && !isGuestAllowed();

  return (
    <main className="container-center">
      <LearnerBadge />
      <section className="card">
        <header className="card-header--lg">
          <h1 className="text-3xl font-semibold">デッサン学習支援システム</h1>
          <p className="text-subtitle mt-2">取り組む演習を選択してください</p>
        </header>
        {sections.map(({ title, note, buttons }) => (
          <section key={title} className="mt-5">
            <h2 className="text-base font-semibold text-gray-800">{title}</h2>
            {/* note 内の \n で改行する */}
            <p className="text-sm text-gray-700 mt-0.5 mb-2 whitespace-pre-line">{note}</p>
            <div className="form-group">
              {buttons.map(({ confirmGuest, ...button }) => (
                confirmGuest && needsConfirm ? (
                  <button key={button.to} type="button" className="btn btn--primary" onClick={() => setGuestTarget(button.to)}>
                    {button.buttonText}
                  </button>
                ) : (
                  <NavigateButton key={button.to} {...button} />
                )
              ))}
            </div>
          </section>
        ))}
      </section>
      {guestTarget && <GuestConfirmDialog to={guestTarget} onCancel={() => setGuestTarget(null)} />}
    </main>
  );
}

export default Home;
